export default __webpack_public_path__ + "static/media/fixed_deposit.627c6a7c.jpg";